<!--党建引领-->
<template>
    <div class="studio_nav_content">
        <div class="content-container1" v-show="showMode==='page'">
            <!-- 理论思想 -->
            <div class="title-container">
                <a class="a-link">思想理论</a>
                <a class="more-link" @click="pageDangJian('思想理论','1')">更多</a>
            </div>
            <div class="list-item-container" >
                <div class="item-container" >
                    <div class="item-one" v-for="item in homeData.llsxList" :key="item.dangjId">
                        <div class="dj-item-l"><div class="dj-yuan"></div></div>
                        <div class="dj-item-r" @click="viewDangj(item)">{{item.title}}</div>
                    </div>
                    <div class="div-100" v-if="homeData.llsxList&&homeData.llsxList.length===0">
                        <dataEmpty title="暂无数据" />
                    </div>
                </div>
            </div>
            <!-- 宣传思想文化工作 -->
            <div class="title-container">
                <a class="a-link">党章党规</a>
                <a class="more-link" @click="pageDangJian('党章党规','2')">更多</a>
            </div>

            <div class="list-item-container" >
                <div class="item-container" >
                    <div class="item-one" v-for="item in homeData.dzdgList" :key="item.dangjId">
                        <div class="dj-item-l"><div class="dj-yuan"></div></div>
                        <div class="dj-item-r" @click="viewDangj(item)">{{item.title}}</div>
                    </div>
                    <div class="div-100" v-if="homeData.dzdgList&&homeData.dzdgList.length===0">
                        <dataEmpty title="暂无数据" />
                    </div>
                </div>
            </div>
            <!-- 党建工作 -->
            <div class="title-container">
                <a class="a-link">文件汇编</a>
                <a class="more-link" @click="pageDangJian('文件汇编','3')">更多</a>
            </div>
            <div class="list-item-container">
                <div class="item-container" >
                    <div class="item-one" v-for="item in homeData.wjhbList" :key="item.dangjId">
                        <div class="dj-item-l"><div class="dj-yuan"></div></div>
                        <div class="dj-item-r" @click="viewDangj(item)">{{item.title}}</div>
                    </div>
                    <div class="div-100" v-if="homeData.wjhbList&&homeData.wjhbList.length===0">
                        <dataEmpty title="暂无数据" />
                    </div>
                </div>
            </div>
            <!-- 支部生活 -->
            <div class="title-container">
                <a class="a-link">支部生活</a>
                <a class="more-link" @click="pageDangJian('支部生活','4')">更多</a>
            </div>
            <div class="list-item-container">
                <div class="item-container" >
                    <div class="item-one" v-for="item in homeData.zbshList" :key="item.dangjId">
                        <div class="dj-item-l"><div class="dj-yuan"></div></div>
                        <div class="dj-item-r" @click="viewDangj(item)">{{item.title}}</div>
                    </div>
                    <div class="div-100" v-if="homeData.zbshList&&homeData.zbshList.length===0">
                        <dataEmpty title="暂无数据" />
                    </div>
                </div>
            </div>
        </div>

        <div class="content-container" v-show="showMode==='detail'">
            <page-dangj :info-mode="infoMode" :title="title" :dj-type="category"
                        @change-mode="changeModel" />
        </div>

        <!--详情模式-->
        <div class="detail-mode" v-if="showMode==='detailInfo'">
            <div class="dj-container">
                <div class="dj-title">{{ form.title }}</div>
                <div class="dj-time">发布时间：{{ timestampToTime(form.releaseTime) }}</div>
                <div class="dj-content" v-html="form.content">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import dataEmpty from "@/components/dataEmpty.vue";
import pageDangj from "@/components/resourceCentre/pageDangj.vue";
import {timestampDate, timestampToTime} from "@/utils/date";
import {homeDangjNew, infoDangj} from "@/api/admin/dangj"

export default {
    name:'djylResourceNew',
    components:{dataEmpty,pageDangj},
    props:{
        courseMode:{
            type: String,
            default:'page',
        },
    },
    watch:{
        courseMode(newValue,oldValue){
            this.showMode = newValue;
        },
    },
    mounted() {
    },
    created() {
        this.queryHomeData();
    },
    data() {
        return {
            showMode:'page',
            timestampDate,
            homeData:{},
            title:'',
            subTitle:'',
            category:'',
            infoMode:"pageSub",
            dangjId:'',
            form:{},  //数据
            timestampToTime,
        }
    },
    methods: {
        queryHomeData(){
            homeDangjNew().then(res=>{
                if (res.data.code === 1) {
                    this.homeData = res.data.data;
                } else {
                    this.$message.error("请求出错");
                }
            })
        },
        pageDangJian(t,c){
            this.title = t;
            this.category = c;
            this.showMode = 'detail';
            this.infoMode = this.infoMode+new Date();
            this.$emit('change-mode',this.showMode);
        },
        changeModel(item){
            this.showMode = item
            this.$emit('change-mode',this.showMode);
        },
        viewDangj(item){
            this.dangjId = item.dangjId;
            this.getDangjInfo();
            this.showMode = "detailInfo"
            this.$emit('change-mode',this.showMode);
        },
        getDangjInfo(){
            infoDangj({ dangjId: this.dangjId }).then(res => {
                if (res.data.code === 1) {
                    this.form = res.data.data;
                }else {
                    this.$message.error("操作失败")
                }
            })
        },
    }
}

</script>

<style scoped>
.studio_nav_content{
    width: 100%;
    height: auto;
    background-color: #fff;
    min-height: calc(100vh - 90px);
}
.content-container1{
    width: 100%;
    margin: auto;
    height: auto;
    padding-left: 10px;
    box-sizing: border-box;
}
.content-container{
    width: 100%;
    margin: auto;
    height: calc(100vh - 90px);
}
.title-container{
    border-bottom: 1px solid #3b62f8;
    display: block;
    unicode-bidi: isolate;
    padding-top: 10px;
    margin-bottom: 10px;
}
.a-link{
    font-size: 18px;
    display: inline-block;
    color: #3b62f8;
    font-weight: bold;
    border-bottom: 2px solid #3b62f8;
    padding-bottom: 0.1rem;
    text-decoration: none;
}
.more-link{
    font-size: 16px;
    display: inline-block;
    color: #595758;
    padding-bottom: 0.1rem;
    text-decoration: none;
    float: right;
    margin-right: 10px;
    cursor: pointer;
}
.more-link:hover{
    color: #3b62f8;
}
.list-item-container{
    width: 100%;
    height: auto;
    display: flex;
}
.item-container{
    float: left;
    width: 100%;
}
.item-one{
    float: left;
    width: 32%;
    display: flex;
    margin-right: 1%;
}

.item-dashboard1{
    width: 32.66%;
    height: auto;
    margin-right: 1%;
    background-color: #fff;

}
.item-dashboard2{
    width: 32.66%;
    height: auto;
    background-color: #fff;
}
.item-title{
    border-bottom: 0.01rem solid #dedede;
}
.share-title{

}
.share-title a {
    font-size: 16px;
    display: inline-block;
    color: #222222;
    font-weight: bold;
    border-bottom: 2px solid #3b62f8;
    padding-bottom: 0.1rem;
    text-decoration: none;
    cursor: pointer;
}


.item-list{
    width: 100%;
    height: auto;
}
.dj-item{
    width: 100%;
    height: 44px;
    display: flex;
    margin-top: 10px;
}
.dj-item-l{
    width: 10px;
    height: 44px;
}
.dj-yuan{
    width: 6px;
    height: 6px;
    border-radius: 3px;
    background-color: #3b62f8;
    margin-top: 8px;
}
.dj-item-r{
    width: calc(100% - 10px);
    height: 44px;
    color: #595758;
    cursor: pointer;
    font-size: 14px;
    line-height: 22px;
}
.dj-item-r:hover{
    color: #3b62f8;
}

.dj-container{
    width: 100%;
    height: auto;
    background-color: #fff;
}
.dj-title{
    height: 45px;
    width: 98%;
    margin: auto;
    line-height: 40px;
    font-size: 18px;
    font-weight: bold;
    text-align: center;
    border-bottom: 1px solid #DDD;
}
.dj-time{
    height: 40px;
    width: 98%;
    margin: auto;
    line-height: 40px;
    font-size: 15px;
    color: #666666;
}
.dj-content{
    width: 96%;
    margin: auto;
    overflow-x: hidden;
}
</style>